import React from 'react'
import * as S from './CityContacts.styled'
import { useShipment } from '@entities/shipment/model'
import { useCityById } from '@entities/cities/hooks'

const CityContacts = (props) => {
    const shipment = useShipment()
    const city = useCityById(shipment.cityId || 1)
    return (
        <S.Container>
            <S.IconContainer>
                <S.Image />
            </S.IconContainer>
            <S.ContentContainer>
                <S.ContentTitle>с 07:00 до 23:00</S.ContentTitle>
                <S.ContentBody href={`tel:${((city ? city.phone : false) || '+7 (495) 363-3500').replace(/\D+/g, '')}`}>
                    {' '}
                    <S.PhoneSpan>{(city ? city.phone : false) || '+7 (495) 363-3500'}</S.PhoneSpan>
                </S.ContentBody>
            </S.ContentContainer>
        </S.Container>
    )
}

export default CityContacts
